import ApiCore from "./api_core";
import { ObsFiltersI, ObsValueI, ObservationI } from "./types";

export default new class {
    all(params={} as ObsFiltersI) {
        return ApiCore.getJson<ObservationI>('observations', params)
    }

    create(encounterID: number, observations: ObsValueI[]) {
        return ApiCore.postJson<ObservationI>('observations', {
            encounter_id: encounterID, observations
        })
    }

    update(id: number, params: ObsValueI) {
        return ApiCore.putJson<ObservationI>(`observations/${id}`, params)
    }

    void(id: number, reason: string) {
        return ApiCore.void(`observations/${id}`, { reason })
    }
}
